import { create } from 'zustand';

/**
 * Video Volume Modal Store Interface
 * Manages state for the post-onboarding video volume collection modal
 */
interface VideoVolumeModalStore {
  /** Whether the modal is currently open */
  isModalOpen: boolean;
  /** The video volume value entered by the user */
  videoVolume: string;
  /** Whether the user has already answered the video volume question */
  hasAnsweredVideoVolume: boolean;
  /** Loading state for saving the video volume */
  isSaving: boolean;
  
  // Actions
  /** Set modal open/closed state */
  setIsModalOpen: (isModalOpen: boolean) => void;
  /** Set the video volume value */
  setVideoVolume: (videoVolume: string) => void;
  /** Set whether user has answered the question */
  setHasAnsweredVideoVolume: (hasAnswered: boolean) => void;
  /** Set saving state */
  setIsSaving: (isSaving: boolean) => void;
  /** Reset all state */
  reset: () => void;
}

/**
 * Zustand store for managing video volume modal state
 * Used to collect video editing volume information after onboarding
 */
const useVideoVolumeModalStore = create<VideoVolumeModalStore>((set) => ({
  isModalOpen: false,
  videoVolume: '',
  hasAnsweredVideoVolume: false,
  isSaving: false,
  
  setIsModalOpen: (isModalOpen) => set({ isModalOpen }),
  setVideoVolume: (videoVolume) => set({ videoVolume }),
  setHasAnsweredVideoVolume: (hasAnswered) => set({ hasAnsweredVideoVolume: hasAnswered }),
  setIsSaving: (isSaving) => set({ isSaving }),
  reset: () => set({
    isModalOpen: false,
    videoVolume: '',
    hasAnsweredVideoVolume: false,
    isSaving: false,
  }),
}));

export { useVideoVolumeModalStore };
export type { VideoVolumeModalStore };
